import { PatientSummary } from "domains/concierge/types";

export function mapPatientGenderToPatientSummaryGender(
    gender?: string | null,
): PatientSummary["gender"] {
    return gender ?? "Unknown";
}
